import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Label } from "reactstrap";
import Chart from "react-apexcharts";
import dayjs from "dayjs";
import { useDispatch, useSelector } from 'react-redux';
import { failed } from '../../utils/Tostify';
import { getOrgInsight } from '../../api/insights';

const OrganizationGraph = (activeTab) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleone = () => setDropdownOpen((prevState) => !prevState);
  const [fromDate, setFromDate] = useState(dayjs().subtract(30, "day").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [timeline, setTimeline] = useState("Daily");
  const [measures, setMeasures] = useState("Total");
  const [groupBy, setGroupBy] = useState("Select");
  const [chartData, setChartData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dropdownOpentwo, setDropdownOpentwo] = useState(false);
  const toggletwo = () => setDropdownOpentwo((prevState) => !prevState);
  let token = useSelector(state => state.userReducer.token);
  const dispatch = useDispatch();

  useEffect(() => {
    if(activeTab.activeTab === "4"){
      fetchOrgInsightData();
    }
}, [activeTab]);

const fetchOrgInsightData = async () => {
  let res;
  try {
    setIsLoading(true);
    res = await getOrgInsight({ values : {fromDate, toDate, timeline, groupBy, measures }, dispatch, token});
    if (res?.status === "SUCCESS") {
      setChartData(res?.data);
      setIsLoading(false);
    }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const chartOptions = {
    series: [{
      name: 'PRODUCT A',
      data: [44, 55, 41, 67, 22, 43]
    }, {
      name: 'PRODUCT B',
      data: [13, 23, 20, 8, 13, 27]
    }, {
      name: 'PRODUCT C',
      data: [11, 17, 15, 15, 21, 14]
    }, {
      name: 'PRODUCT D',
      data: [21, 7, 25, 13, 22, 8]
    }],
    options: {
      theme: {
        palette: 'palette2',
        monochrome: {
            shadeIntensity: 0.6
      }},
      chart: {
        type: 'bar',
        height: 350,
        stacked: true
      }
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4 pt-4">
        <h4>Oranizations</h4>
        <div className="d-flex justify-content-between align-items-center gap-4">
          <Label>Filter By : </Label>
          <div className="drop_block">
            <Dropdown isOpen={dropdownOpen} toggle={toggleone}>
              <DropdownToggle caret size="xl" className="filter_block">
                Organization <i className="fa fa-caret-down"></i>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">1</DropdownItem>
                <DropdownItem className="d-flex gap-2 content_drop align-items-center">2</DropdownItem>
                <DropdownItem className="d-flex gap-2 content_drop align-items-center">3</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <p>OR</p>
          <div className="drop_block">
            <Dropdown isOpen={dropdownOpentwo} toggle={toggletwo}>
              <DropdownToggle caret size="xl" className="filter_block">
                State <i className="fa fa-caret-down"></i>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem className="d-flex gap-2 drop_block_content align-items-center">1</DropdownItem>
                <DropdownItem className="d-flex gap-2 content_drop align-items-center">2</DropdownItem>
                <DropdownItem className="d-flex gap-2 content_drop align-items-center">3</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      </div>
      <div className="">
        <div className="graph_block"><div className="chart-apex">
            <Chart
              options={chartOptions.options}
              series={chartOptions.series}
              type="bar"
              width="100%"
              height="400"
            />
          </div></div>
      </div>
    </>
  );
};

export default OrganizationGraph;
